import { ServiceBase } from '../../../../core/services/ServiceBase'
import PortfolioScoreProxy from './proxy'

class PortfolioScoreService extends ServiceBase {
  getScoreRangesCreditRisk(params) {
    return this.applyMemoryCache(
      'portfolioInsights/getScoreRangesCreditRisk',
      params,
    )(() => PortfolioScoreProxy.getScoreRangesCreditRisk(params))
  }
  getScoreRangesPerformance(params) {
    return this.applyMemoryCache(
      'portfolioInsights/getScoreRangesPerformance',
      params,
    )(() => PortfolioScoreProxy.getScoreRangesPerformance(params))
  }
  //Score Trend
  getRiskTrend(params) {
    return this.getData(() => PortfolioScoreProxy.getRiskTrend(params))
  }
  getPerformanceTrend(params) {
    return this.getData(() => PortfolioScoreProxy.getPerformanceTrend(params))
  }
  getTrendConfig(params) {
    return this.getData(() => PortfolioScoreProxy.getTrendConfig(params))
  }
  postTrendConfig(params) {
    return this.getData(() => PortfolioScoreProxy.postTrendConfig(params))
  }
  //distribution
  getDistributionCreditRisk(params) {
    return this.getData(() =>
      PortfolioScoreProxy.getDistributionCreditRisk(params),
    )
  }
  getDistributionPerformance(params) {
    return this.getData(() =>
      PortfolioScoreProxy.getDistributionPerformance(params),
    )
  }
  //top 10 companies
  getHighestCreditRisk(params) {
    return this.getData(() => PortfolioScoreProxy.getHighestCreditRisk(params))
  }
  getHighestPerformance(params) {
    return this.getData(() => PortfolioScoreProxy.getHighestPerformance(params))
  }
  getBiggestCreditRisk(params) {
    return this.getData(() => PortfolioScoreProxy.getBiggestCreditRisk(params))
  }
  getBiggestPerformance(params) {
    return this.getData(() => PortfolioScoreProxy.getBiggestPerformance(params))
  }
  getLargestDeclineCreditRisk(params) {
    return this.getData(() =>
      PortfolioScoreProxy.getLargestDeclineCreditRisk(params),
    )
  }
  getLargestDeclinePerformance(params) {
    return this.getData(() =>
      PortfolioScoreProxy.getLargestDeclinePerformance(params),
    )
  }
  //trend by port
  getTrendByPortfolioCreditRisk(params) {
    return this.getData(() =>
      PortfolioScoreProxy.getTrendByPortfolioCreditRisk(params),
    )
  }
  getTrendByPortfolioPerformanceScore(params) {
    return this.getData(() =>
      PortfolioScoreProxy.getTrendByPortfolioPerformanceScore(params),
    )
  }
  //export
  exportDistributionCreditRisk(params) {
    return this.getFileDownload(() =>
      PortfolioScoreProxy.exportDistributionCreditRisk(params),
    )
  }
  exportDistributionPerformance(params) {
    return this.getFileDownload(() =>
      PortfolioScoreProxy.exportDistributionPerformance(params),
    )
  }
  exportTopCreditRiskScore(params) {
    return this.getFileDownload(() =>
      PortfolioScoreProxy.exportTopCreditRiskScore(params),
    )
  }
  exportTopPerformanceScore(params) {
    return this.getFileDownload(() =>
      PortfolioScoreProxy.exportTopPerformanceScore(params),
    )
  }
  exportTrendByPortfolioCreditRiskScore(params) {
    return this.getFileDownload(() =>
      PortfolioScoreProxy.exportTrendByPortfolioCreditRiskScore(params),
    )
  }
  exportTrendByPortfolioPerformanceScore(params) {
    return this.getFileDownload(() =>
      PortfolioScoreProxy.exportTrendByPortfolioPerformanceScore(params),
    )
  }
}

const portfolioScoreService = new PortfolioScoreService()
export default portfolioScoreService
